import * as React from 'react'

const styles = {
  main: {
    margin: '0 auto',
    width: '100%',
    height: '100%',
  },
}

export default function Layout({ children }: { children?: React.ReactNode }) {
  return (
    <>
      <div style={styles.main}>{children}</div>
      <link href="https://use.typekit.net/wny0ohy.css" rel="stylesheet" />
    </>
  )
}
